import {  Grid, Link } from '@mui/material';
import ResponseWrapper from './ResponseWrapper'
import Profile from './Profile'
import {ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK, PIONEER_RELATIVE_PATH} from '../utils/main-links'

const ResponseLoggedIn = () => {
  
    return (
        <ResponseWrapper>
            <Grid container flexDirection="column" alignContent="center">
                <Grid item xs={12}>
                    <p 
                        style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700'}}
                    >
                        Thank you for your purchase!
                    </p>
                </Grid>

                <Grid item xs={12}>
                    <p style={{paddingTop:'15px', textAlign: 'center', marginTop:'0px' }}>
                        Premium has been activated for the following account
                    </p> 
                </Grid>

                <Profile/>
            
                <Grid container justifyContent="center" flexDirection="column" alignContent="center" alignItems='center'>

                    <Grid item md={8} className='back-mutual-wrapper' style={{marginTop: '15px'}}>
                        <Link 
                            href={ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK} 
                            className='back-mutual-link-inside'
                        >
                            Manage my Subscription
                        </Link>
                    </Grid>

                    <Grid container flexDirection='column' alignContent='center' alignItems='center'>
                        <Link className='back-mutual-link-logged' href={PIONEER_RELATIVE_PATH}>Back to sale page</Link>
                    </Grid>
                </Grid>
            </Grid>
        </ResponseWrapper>
    );
}

export default ResponseLoggedIn;
